import { IFilterData } from "interfaces/FilterProps";
import { IOccurrence } from "interfaces/Occurrence";
import { IUser } from "interfaces/User";
import { client } from "./api";
import { IMaintenance } from "interfaces/Maintenance";

export interface Comment {
  attendant: IUser;
  content: string;
  id: string;
  occurrence?: IOccurrence;
  maintenance?: IMaintenance;
  createdAt: Date;
  updatedAt: Date;
}

export interface createComment {
  id?: string;
  content: string;
  occurrence?: string;
  maintenance?: string;
}

export async function geCommentsService(
  occurrenceId: string
): Promise<IFilterData<Comment>> {
  const api = client();
  const response = await api.get<IFilterData<Comment>>("comments", {
    params: {
      relations: JSON.stringify({ occurrence: true, maintenance:true, attendant: true }),
      params: JSON.stringify([{ occurrence: { id: occurrenceId } },{ maintenance: { id: occurrenceId } }])
    },
  });
  return response.data;
}

export async function saveComment({ id, content, occurrence, maintenance }: createComment) {
  const api = client();
  if (id) {
    const response = await api.patch("comments", {
      id,
      content,
      occurrence,
      maintenance
    });
    return response.data;
  }
  const response = await api.post("comments", {
    content,
    occurrence,
    maintenance
  });
  return response.data;
}
